import { Countries } from "promospot/dist/src/index.model";
import { PreviousUrlObject } from "./home.model";

export class BackToUrlStorageAction 
{
  static readonly type = '[backTo] set url';
  constructor(public backTo: PreviousUrlObject)
  {

  }
}

export class CountryListStorageAction
{
  static readonly type = '[countryLs] set country';
  constructor(public country: Countries[])
  {

  }
}
